"use client";
import { useEffect, useState } from "react";
import { getCookie } from "@repo/client-cookies";

type Section = "topshop" | "topman" | null;

export function useShouldShowOverlay() {
  const floor = getCookie("floor");

  const [showLogoOverlay, setShowLogoOverlay] = useState<boolean>(false);
  const [isOverlayReady, setIsOverlayReady] = useState<boolean>(false);
  const [activeFloor, setActiveFloor] = useState<Section | null>(null);

  useEffect(() => {
    if (typeof window === "undefined" || !window.sessionStorage) {
      return;
    }
    if (floor) {
      const floorCookie = floor === "1000" ? "topshop" : "topman";
      setActiveFloor(floorCookie);
    }

    const isFirstNavigation = sessionStorage.getItem("first") === "1";
    if (isFirstNavigation) {
      setShowLogoOverlay(true);
    } else {
      setShowLogoOverlay(false);
    }

    setIsOverlayReady(true);
  }, [floor]);

  return {
    showLogoOverlay,
    isOverlayReady,
    activeFloor,
  };
}
